module.exports = __webpack_public_path__ + "img/urgent.7167ea0c.svg";